interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    pages.push(i);
  }

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${btnBase} ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(current + 1)}
        disabled={current === totalPages}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}